"use client";

import { Button } from "@radix-ui/themes";
import _ from "lodash";
import { useSession } from "next-auth/react";
import { performSignOut } from "@/utils/signOut";

type ButtonProps = React.ComponentPropsWithoutRef<typeof Button>;
interface SignOutButtonProps extends ButtonProps {
    text?: string;
}

export default function SignOutButton(props: SignOutButtonProps) {
    const { text, ...buttonProps } = props;
    const { data: session } = useSession();

    return (
        <Button
            onClick={() => {
                const provider = _.get(session, "user.provider");
                performSignOut(provider);
            }}
            {...buttonProps}>
            {text ?? "Sign Out"}
        </Button>
    );
}
